<template>
    <div
        class="modal right fade trader-info"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"       
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title mr-auto p-2" >Offerings</h5>
              <div class="p-2">
                <div class="form-group">
                    <select class="form-control" @change="statusChange(status)" v-model="status" >
                        <option value="DELETED">DELETE</option>
                        <option value="HOLD">HOLD</option>
                        <option value="SUSPENDED">SUSPEND</option>
                    </select>
                </div>
              </div>
              <div class="p-2">  
                <button :disabled="customerOfferings.length == 0" type="button" @click="OfferingStatusChange()" class="btn btn-warning">{{statustext}} All</button>
                <button type="button" class="close"  @click="$emit('close')">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div> 
            </div>
            <div class="modal-body">
              <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
              <table class="table align-items-center table-flush table-hover bidtbl">
                <thead class="thead-light psticky">
                  <tr>
                    <th scope="col" class="text-center">CUSIP</th>
                    <th scope="col"  class="sort text-left">ACCOUNT</th>
                    <th scope="col"  class="sort text-right">COST </th>
                    <th scope="col"  class="sort text-center">BOUGHT</th>
                    <th scope="col"  class="sort text-center">HOLDING <br> QTY</th>
                    <th scope="col"  class="sort text-center">OFFERED <br> QTY</th>
                    <th scope="col"  class="sort text-center">OFFERED <br> PRICE</th>
                    <th scope="col"  class="sort text-center">SPREAD</th>
                    <th scope="col"  class="sort text-center">OFFER <br> STATUS</th>

                  </tr>
                </thead>
                <tbody>
                  <tr v-if="customerOfferings.length == 0 && !loading">
                      <td><p class="nodata">No data available</p>
                      </td>
                  </tr>
                  <tr v-for="offer in customerOfferings" :key="offer.offerId">
                    <td><span class="cusips">{{offer.cusipVal}}</span></td>
                    <td class="text-left text-primary p-0">{{offer.account}}</td>
                    <td class="text-right text-success">{{offer.cost | currency}}</td>
                    <td class="text-center">{{offer.boughtDate ? moment(offer.boughtDate).format("MM/DD/YYYY") : 'N/A' }}</td>
                    <td class="text-center">{{offer.quantity }}</td>
                    <td class="text-center text-success">{{offer.offerInventoryQuantity}}</td>
                    <td class="text-center">{{offer.offerPrice | currency}}</td>
                    <td class="text-center">{{(offer.offerPrice - offer.cost).toFixed(3)}}</td>
                    <td class="text-center">{{offer.offerStatus}}</td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
</template>

<script>
    import authService from "@/authService";
    import config from "@/config";
    export default {
        name: 'customerOfferingsmodal',
        components :{
            
        },
        props: ['customerData'],
        data() {
            return {
                loading : false,
                errors: [],
                customerOfferings : [],
                totalRecords : null,
                status : "DELETED",
                statustext : "DELETE",
                offerids:[]
            };
        },
        methods: { 
          statusChange(status){
            if(status == 'DELETED'){
              this.statustext = "DELETE"
            }
            if(status == 'SUSPENDED'){
              this.statustext = "SUSPEND"
            }
             if(status == 'HOLD'){
              this.statustext = "HOLD"
            }

          },
          OfferingStatusChange(){
              this.$confirm("Are you sure you want to "+this.statustext+" all offerings?","","",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
                this.loading = true;
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken() }
                };
                let postData = {"status":this.status,"cognitoSub":authService.getUser().cognitoSub,"offeringIds":this.offerids}
                this.$http
                .put(
                config.baseUrlBidSide +
                    "/offer/suspend-customer-offerings",
                   postData,
                    auth
                )
                .then(() => {
                  this.$alert(this.statustext+" in progress");
                  this.$emit('close');
                  this.loading = false;
                })
              });
          }, 
          getCustomerOfferings(){
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            this.$http
            .get(
              config.baseUrlBidSide +
                "/offer/customer-offer-list?customerId="+this.customerData.id,
                auth
            )
            .then(result => {
              this.customerOfferings = result.data;
              this.offerids = [];
              this.customerOfferings.forEach(ele =>{
                this.offerids.push(ele.offerId);
              })
              this.loading = false;
            })
          },
           getAllAccountList(){
            this.loading = true;
              const auth = {
                  headers: { 'org-token' : authService.getOrgToken() }
              };
              this.$http
              .get(
              config.baseUrlBidSide +
                  "/inventory/account-map-list",
                  auth
              )
              .then(result => {
                this.accountList = result.data;
                this.getCustomerOfferings();

              })
          }, 
           getAccountName(accountMappingId){
            let inv  = this.accountList.find(o => o.accountMappingId === accountMappingId);
            if(inv){
                return inv.customerName +'-'+inv.account 
            }
          } 
        },
        mounted(){
          this.getCustomerOfferings();
          //this.getAllAccountList()

        }
    };
    </script>